import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { Environment } from '../models/environment.model';
import { ENVIRONMENT_INJECTION_TOKEN } from '@ls/models-environment';

type LocalizationTranslations = Record<string, string>;

@Injectable({
  providedIn: 'root',
})
export class RegionalizationTranslationsApiService {
  private readonly environment = inject<Environment>(
    ENVIRONMENT_INJECTION_TOKEN
  );
  private readonly httpClient = inject(HttpClient);

  public loadTranslations(
    fileName: string
  ): Observable<LocalizationTranslations> {
    const url = `${this.environment.translationsApiUrl}/${fileName}`;

    return this.httpClient.get<LocalizationTranslations>(url);
  }

  public loadLocalTranslations(
    fileName: string
  ): Observable<LocalizationTranslations> {
    const url = `./localization/${fileName}`;

    return this.httpClient.get<Record<string, string>>(url);
  }
}
